<template>
	<UHeader
		title="★"
		to="/"
	>
		<template v-if="viewer && viewer.isAdmin">
			<UNavigationMenu
				:items="navItems"
				content-orientation="vertical"
			/>
		</template>

		<template #right>
			<template v-if="viewer && viewer.isAdmin">
				<UDropdownMenu
					:items="userMenuItems"
					:content="{ align: 'end' }"
				>
					<template #default="{ open }">
						<button class="flex items-center gap-1 cursor-pointer">
							<UUser
								:name="viewerName || 'Admin'"
								:avatar="viewerPicture && {
									src: viewerPicture,
								} || undefined"
							/>
							<UIcon
								name="i-heroicons-chevron-down"
								class="size-4 text-(--ui-text-muted) transition-transform duration-200"
								:class="{ 'rotate-180': open }"
							/>
						</button>
					</template>
				</UDropdownMenu>
			</template>
			<template v-else>
				<UButton
					v-if="viewer"
					to="/logout"
					color="neutral"
					variant="soft"
				>Log out</UButton>
				<UButton
					v-else
					to="/login"
					color="neutral"
					variant="soft"
				>Log in</UButton>
			</template>
		</template>

		<template #body>
			<UNavigationMenu
				:items="navItems"
				orientation="vertical"
			/>
		</template>
	</UHeader>

	<UMain>
		<UContainer class="py-6 px-4">
			<slot />
		</UContainer>
	</UMain>
</template>

<script setup lang="ts">
const { viewer } = useViewer();
const route = useRoute();

const userMenuItems = computed(() => [
	[
		{
			label: "View profile",
			icon: "i-heroicons-user",
			to: {
				name: "users-id",
				params: {
					id: viewer.value!.id,
				},
			},
		},
		{
			label: "Log out",
			icon: "i-heroicons-arrow-right-on-rectangle",
			to: "/logout",
		},
	],
]);

// less used pages, nested under "More"
const moreNavItems = [
	{
		label: "GoHighLevel",
		to: "/gohighlevel",
	},
];

const navItems = computed(() => [
	{
		label: "Events",
		to: "/events",
	},
	{
		label: "Users",
		to: "/users",
	},
	{
		label: "Agent Prospects",
		to: "/agent-prospects",
	},
	{
		label: "Agents",
		to: "/agents",
	},
	{
		label: "Offices",
		to: "/offices",
	},
	{
		label: "Properties",
		to: "/properties",
	},
	{
		label: "More",
		children: moreNavItems,
		// a parent item has no route of its own to be active by
		active: moreNavItems.some(item => route.path.startsWith(item.to)),
	},
]);

const viewerName = computed(() => {
	const v = viewer.value;
	return v?.__typename === "AgentUser" || v?.__typename === "ClientUser" ? v.name : null;
});

const viewerPicture = computed(() => {
	const v = viewer.value;
	if (v?.__typename === "AgentUser" || v?.__typename === "ClientUser") {
		return v.picture?.uri ?? null;
	}
	return null;
});
</script>

